/**
 * Created by fers on 05.02.16.
 */

import React from 'react';
import {FormattedMessage, injectIntl, defineMessages, IntlShape} from 'react-intl';

export let wrapNotFound = (ComposedComponent, checkFunction, returnNull = false) => (class extends React.Component {
    render() {
        if (checkFunction(this.props)) {
            return <ComposedComponent {...this.props} />;
        } else {
			console.warn(
				'[NotFound]',
				ComposedComponent.displayName || ComposedComponent.name || 'Unknown',
				'checkFunction returned falsy. Props:',
				this.props
			);
			if (returnNull) {
				return null;
			}

            return (
                <div className="NotFound">
                    <h2 className="title-underline">404: <FormattedMessage defaultMessage="Not found" id="NotFound.title" /></h2>

                    <p style={{"font-size": "1.5em"}}><FormattedMessage defaultMessage="The page you are looking for doesn't exists" id="NotFound.description" /></p>

                    <p style={{"padding-top": '3em'}}><FormattedMessage defaultMessage="If you think this is an error, contact our" id="NotFound.support1"/>{" "}
                    <a href="https://www.dativery.com/support/"><FormattedMessage defaultMessage="support" id="NotFound.support2"/></a><FormattedMessage defaultMessage="." id="NotFound.support3"/>
                    </p>


                </div>
            );
        }
    }
});
